import { useEffect, useState } from "react";
import api, { formatErr } from "@/lib/api";
import { toast } from "sonner";
import { CheckCircle, XCircle } from "@phosphor-icons/react";

export default function RankTrustReviewModeration(){
  const [items,setItems]=useState([]);
  const [loading,setLoading]=useState(true);
  const [busy,setBusy]=useState(null);

  const load=async()=>{
    try{
      const {data}=await api.get("/admin/ranktrust-reviews",{params:{status:"pending_moderation"}});
      setItems(data.items||[]);
    }catch(e){toast.error(formatErr(e));}
    finally{setLoading(false);}
  };

  useEffect(()=>{load();},[]);

  const moderate=async(item,status)=>{
    const label=status==="published"?"Publish this review":"Remove this review for a policy reason";
    const notes=window.prompt(label+" — enter the moderation reason:");
    if(!notes||notes.trim().length<5)return;
    setBusy(item.id);
    try{
      await api.post("/admin/ranktrust-reviews/"+item.id+"/moderate",{status,notes:notes.trim()});
      setItems(current=>current.filter(x=>x.id!==item.id));
      toast.success(status==="published"?"Review published":"Review removed for policy");
    }catch(e){toast.error(formatErr(e));}
    finally{setBusy(null);}
  };

  return <div className="p-6 lg:p-10 max-w-6xl space-y-7">
    <header><div className="label-tiny">RankTrust Reviews</div><h1 className="font-display text-4xl font-black tracking-tighter mt-1">Review Moderation</h1><p className="text-zinc-500 mt-2 max-w-3xl">Every rating follows the same moderation path. Businesses do not control publication based on whether a review is positive or negative.</p></header>
    {loading?<div className="bento p-8 text-zinc-500">Loading moderation queue…</div>:items.length===0?<div className="bento p-8 text-zinc-500">No reviews are waiting for moderation.</div>:<div className="space-y-4">{items.map(item=><article key={item.id} className="bento p-6 space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3"><div><div className="font-bold text-lg">{item.reviewer_name||"RankTrust reviewer"}</div><div className="text-xs text-zinc-500 mt-1">{item.verification_type==="invited_customer"?"Invited customer review":"RankTrust review"} · {item.created_at?new Date(item.created_at).toLocaleString():""}</div></div><div className="text-xl text-amber-500" aria-label={item.rating+" out of 5 stars"}>{"★".repeat(item.rating)}{"☆".repeat(5-item.rating)}</div></div>
      <p className="text-zinc-700 whitespace-pre-wrap">{item.comment||"No written comment."}</p>
      <div className="flex flex-wrap gap-2"><button className="btn-primary" disabled={busy===item.id} onClick={()=>moderate(item,"published")}><CheckCircle size={15}/> Publish</button><button className="btn-secondary" disabled={busy===item.id} onClick={()=>moderate(item,"removed_for_policy")}><XCircle size={15}/> Remove for policy</button></div>
    </article>)}</div>}
  </div>;
}
